import request from 'utils/request';
import { REGIONS_URL } from 'constants/api';

/**
 * Requests all regions
 * @returns { Promise }
 */
export const getRegionsRequest = (productId = null, analog = false) =>
  request.get(REGIONS_URL, { params: { product: productId, analog } });
